import React, { FC } from 'react'

import Container from '@Components/CMS/Container'
import { ProductSlider } from '@Domains/Product/Features/ProductSlider/ProductSlider'
import { ProductTileProps } from '@Domains/Product/Tiles/types'
import { useTranslation } from '@Globals/Translations'

import styles from './PreviouslySeenProducts.module.scss'

interface PreviouslySeenProductsProps {
  id?: string
  products: ProductTileProps[]
}

export const PreviouslySeenProducts: FC<PreviouslySeenProductsProps> = ({ id, products }) => {
  const { t } = useTranslation()

  return (
    <Container
      className={styles.previouslySeenProducts}
      id={id}
      width="medium"
    >
      <p className={styles.header}>{t('FP_PRODUCTS_OF_INTEREST_TITLE')}</p>
      <ProductSlider
        products={products}
        sourceID="PRODUCTS_THAT_MIGHT_INTEREST_YOU"
      />
    </Container>
  )
}
